/* eslint-disable */
import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import CircleIcon from '@mui/icons-material/Circle';

import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    fontSize: {
        fontSize: 21,
    },
    wrapper: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
    icon: {
        fontSize: '1.5em',
    },
    count: {
        position: 'absolute',
        color: '#fff',
        fontWeight: 500,
        fontSize: '0.8em',
    },
}));

const UserModPermission = (props) => {
    //console.log("props", props);
    const { value, header } = props;
    const classes = useStyles();
    return (
        <>
            {!header ? (
                <Box display="flex" flexDirection="row">
                    <Tooltip aria-label={''} title={''}>
                        <RemoveCircleRoundedIcon
                            className={classes.fontSize}
                            sx={{ color: value.permission == 0 ? theme.palette.error.main : theme.palette.grey[500] }}
                            onClick={(event) => props.setUserPermission(props.rowIndex, props.colIndex, props.column, 0)}
                        />
                    </Tooltip>
                    <Tooltip aria-label={''} title={''}>
                        <CheckCircleRoundedIcon
                            className={classes.fontSize}
                            sx={{
                                color:
                                    value.permission == 1
                                        ? theme.palette.success.main
                                        : theme.palette.grey[500],
                            }}
                            onClick={(event) =>
                                props.setUserPermission(
                                    props.rowIndex,
                                    props.colIndex,
                                    props.column,
                                    1
                                )
                            }
                        />
                    </Tooltip>
                </Box>
            ) : (
                <Box display="flex" flexDirection="column">
                    <Box display="flex" flexDirection="row">
                        <Tooltip title={''} aria-label={''}>
                            <RemoveCircleRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: props.column.permission == 0 ? theme.palette.error.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserHeadPermission(props.colIndex, props.column, 0)}
                            />
                        </Tooltip>
                        <Tooltip
                            title={''}
                            aria-label={''}>
                            <CheckCircleRoundedIcon
                                className={classes.fontSize}
                                sx={{ color: props.column.permission == 1 ? theme.palette.success.main : theme.palette.grey[500] }}
                                onClick={(event) => props.setUserHeadPermission(props.colIndex, props.column, 1)}
                            />
                        </Tooltip>
                    </Box>
                    {props.column.id != "allModules" ? <Box display="flex" flexDirection="row">
                        <Tooltip title={''} aria-label={''}>
                            <Box
                                className={
                                    classes.wrapper
                                }
                                style={{
                                    fontSize: 14,
                                }}
                            >
                                <CircleIcon
                                    style={{
                                        color: '#d32f2f',

                                    }}
                                    className={
                                        classes.icon
                                    }
                                />
                                <Typography
                                    component="span"
                                    className={
                                        classes.count
                                    }>
                                    {props.column.yesNoCount.noCount}
                                </Typography>
                            </Box>
                        </Tooltip>
                        <Tooltip
                            title={''}
                            aria-label={''}>
                            <Box
                                className={
                                    classes.wrapper
                                }
                                style={{
                                    fontSize: 14,
                                }}
                            >
                                <CircleIcon
                                    style={{
                                        color: '#2e7d32',

                                    }}
                                    className={
                                        classes.icon
                                    }
                                />
                                <Typography
                                    component="span"
                                    className={
                                        classes.count
                                    }>
                                    {props.column.yesNoCount.yesCount}
                                </Typography>
                            </Box>
                        </Tooltip>
                    </Box> : <Box>&nbsp;</Box>}
                </Box>
            )}
        </>
    );
};

export default UserModPermission;
